module.exports = __webpack_public_path__ + "static/media/bulldog.63632415.svg";